// extracted by mini-css-extract-plugin
export default {"principlesSection":"Principles_principlesSection__Awf8F","principlesGrid":"Principles_principlesGrid__wfBY+","principleCard":"Principles_principleCard__6PC8+"};